var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15234 18.7168C9.30879 18.9877 9.53379 19.2127 9.80474 19.3691C10.0757 19.5256 10.383 19.6079 10.6959 19.6079C11.0088 19.6079 11.3161 19.5256 11.5871 19.3691C11.858 19.2127 12.083 18.9877 12.2395 18.7168",
    stroke: "#113E5C",
    strokeWidth: 1.78241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90765 13.6594C2.79123 13.787 2.71439 13.9457 2.6865 14.1161C2.65861 14.2866 2.68085 14.4615 2.75054 14.6196C2.82022 14.7776 2.93433 14.912 3.07899 15.0064C3.22365 15.1008 3.39262 15.1511 3.56536 15.1513H17.8246C17.9973 15.1513 18.1663 15.1012 18.3111 15.007C18.4558 14.9128 18.5701 14.7785 18.64 14.6206C18.7098 14.4626 18.7323 14.2878 18.7046 14.1173C18.677 13.9468 18.6003 13.788 18.4841 13.6603C17.2988 12.4384 16.0422 11.14 16.0422 7.13043C16.0422 5.71225 15.4788 4.35217 14.476 3.34937C13.4732 2.34657 12.1132 1.7832 10.695 1.7832C9.27682 1.7832 7.91673 2.34657 6.91393 3.34937C5.91113 4.35217 5.34776 5.71225 5.34776 7.13043C5.34776 11.14 4.09028 12.4384 2.90765 13.6594Z",
    stroke: "#113E5C",
    strokeWidth: 1.78241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.403c76383935360d499009321bdab4b3.svg";
export { ForwardRef as ReactComponent };